import { SerializedData } from 'bernie-core';

import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';

import * as queryString from 'query-string';

const HOTEL_NAME = '1'; // eg: `hicago-Mariott-Suites-Deerfield`
const INFOSITE = '2'; // eg: `Hotel-Information`

export const generateBackToHsrUrlObj = (
  searchCriteria: SearchCriteriaModel,
  ignoreParams: string[],
  includeParams: SerializedData
): { pathname: string; search: string } => {
  const sqaParsedOut = SearchQueryAdapter.parseOut(Object.assign({}, searchCriteria.toJSON([HOTEL_NAME, INFOSITE, ...ignoreParams])));

  return {
    pathname: '/Hotel-Search',
    search: queryString.stringify({ ...sqaParsedOut, ...includeParams }),
  };
};

export const updateSlotsParamForMapTravelAds = (url: string): string => url.replace(RegExp('(slots=)[^&]+'), '$1HSR_Map');
